import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { loginRoute } from '../config/routes.config';
import { getSession } from '../services/storage.service';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(
    private router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkCanActivate();
  }

  private checkCanActivate() {
    const session = getSession();
    if (!session || !session.token) {
      this.router.navigateByUrl(loginRoute);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/guards/logged-in.guard.ts